import { createSlice } from "@reduxjs/toolkit";

const initialPortalDashboardDataState = {
  isModalVisible: false,
  title: "",
  component: null,
};

const portalDashboardDataSlice = createSlice({
  name: "portalDashboardData",
  initialState: initialPortalDashboardDataState,
  reducers: {
    setPortalData: (_state, action) => action.payload,
    setModalVisiblity: (state, action) => ({ ...state, ...action.payload }),
  },
});
const helpSectionStateSlice = createSlice({
  name: "helpSectionState",
  initialState: false,
  reducers: {
    setHelpSectionState: (_state, action) => action.payload,
  },
});

const reducerHeaderSlice = createSlice({
  name: "reducerHeader",
  initialState: true,
  reducers: {
    setReduceHeader: (_state, action) => action.payload,
  },
});

const portalDashboardObjectSlice = createSlice({
  name: "portalDashboardObject",
  initialState: {},
  reducers: {
    setPortalDashboardObject: (_state, action) => action.payload,
  },
});

export const { setPortalData, setModalVisiblity } = portalDashboardDataSlice.actions;
export const { setPortalDashboardObject } = portalDashboardObjectSlice.actions;
export const { setHelpSectionState } = helpSectionStateSlice.actions;
export const { setReduceHeader } = reducerHeaderSlice.actions;

export const portalDashboardData = portalDashboardDataSlice.reducer;
export const helpSectionState = helpSectionStateSlice.reducer;
export const onReduceHeader = reducerHeaderSlice.reducer;
export const portalDashboardObject = portalDashboardObjectSlice.reducer;

export default portalDashboardDataSlice.reducer;
